import { LoadingIndicator } from "@k8slens/lds";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { sanitizeUrl } from "@braintree/sanitize-url";
import { useLocalStorage } from "usehooks-ts";
import { getRedirectAuthUri, isAuthorizedRedirectUri } from "src/services/getRedirectAuthToLensDesktopUrl";
import {
  checkoutBaseUrl,
  goToPlanCheckoutLocalStorageKey,
  legacyKeycloakIframeRedirectLocalStorageKey,
  lensDesktopAuthUrlLocalStorageKey,
} from "src/constants";
import { useAnalytics } from "src/hooks/useAnalytics";
import { Context } from "@segment/analytics-next";
import { getCheckoutPlanCode } from "src/services/getCheckoutPlanCode";

export function RedirectToLensDesktop() {
  const [lensDesktopRedirectUri, , removeLensDesktopRedirectUri] = useLocalStorage(
    legacyKeycloakIframeRedirectLocalStorageKey,
    "",
  );
  const [lensDesktopAuthUrl, , removeLensDesktopAuthUrl] = useLocalStorage(lensDesktopAuthUrlLocalStorageKey, "");
  const [goToPlanCheckout, , removeGoToPlanCheckout] = useLocalStorage(goToPlanCheckoutLocalStorageKey, "");

  const location = useLocation();
  const { trackRedirect } = useAnalytics();

  useEffect(() => {
    const doRedirect = (url: string) => {
      let trackRedirectPromise: Promise<void | Context> | undefined;

      if (trackRedirect) {
        trackRedirectPromise = trackRedirect(url);
      }

      if (trackRedirectPromise) {
        trackRedirectPromise.finally(() => {
          window.location.replace(url);
        });
      } else {
        window.location.replace(url);
      }
    };

    if (lensDesktopAuthUrl && goToPlanCheckout) {
      removeLensDesktopRedirectUri();
      removeLensDesktopAuthUrl();
      removeGoToPlanCheckout();

      const planCode = getCheckoutPlanCode(goToPlanCheckout);
      const redirectUri = encodeURIComponent(lensDesktopAuthUrl);
      const checkoutUrl = `${checkoutBaseUrl}/subscribe/${planCode}?redirect_uri=${redirectUri}`;

      doRedirect(checkoutUrl);

      return;
    }

    if (lensDesktopRedirectUri) {
      const redirectAuthUri = getRedirectAuthUri(location.search, lensDesktopRedirectUri);

      if (isAuthorizedRedirectUri(redirectAuthUri)) {
        const sanitizedRedirectAuthUri = sanitizeUrl(redirectAuthUri);

        doRedirect(sanitizedRedirectAuthUri);
      }
    }
  }, [
    location.search,
    lensDesktopRedirectUri,
    trackRedirect,
    lensDesktopAuthUrl,
    goToPlanCheckout,
    removeLensDesktopRedirectUri,
    removeLensDesktopAuthUrl,
    removeGoToPlanCheckout,
  ]);

  return <LoadingIndicator size="2xl" />;
}
